export const LEAD_TYPE = {
  GENERAL_INFO: 'GENERAL_INFO',
  TEST_DRIVE: 'TEST_DRIVE'
}
